import React from "react";

const ScorePlusMessage = ({
  message,

  clearMessage,
}) => {
  if (!message) return null;

  return (
    <div
      className={`rounded-xl px-4 py-1 text-sm
            ${
              message.type === "error"
                ? "bg-red-900 text-red-200"
                : "bg-green-900 text-green-200"
            }
        `}
    >
      <div className="flex justify-between">
        <span>{message.text}</span>
        <button onClick={clearMessage} className="w-fit px-2 p-1">✕</button>
      </div>
    </div>
  );
};

export default ScorePlusMessage;
